import ImageGallery from 'react-image-gallery';
import FadeIn from 'react-fade-in';
import image1 from './images/1.jpg';
import image1thumb from './images/1thumb.jpg';
import image2 from './images/2.jpg';
import image2thumb from './images/2thumb.jpg';
import image3 from './images/3.jpg';
import image3thumb from './images/3thumb.jpg';
import image4 from './images/4.jpg';
import image4thumb from './images/4thumb.jpg';
import image5 from './images/5.jpg';
import image5thumb from './images/5thumb.jpg';
import image6 from './images/6.jpg';
import image6thumb from './images/6thumb.jpg';

export const Gallery = ({galleryindex}) => {

    const images = [
        {
            original: image4,
            thumbnail: image4thumb,
        },
        {
            original: image5,
            thumbnail: image5thumb,
        },
        {
            original: image6,
            thumbnail: image6thumb,
        },
        {
            original: image2,
            thumbnail: image2thumb,
        },
        {
            original: image1,
            thumbnail: image1thumb,
        },
        {
            original: image3,
            thumbnail: image3thumb,
        }

    ];

    return (
        <FadeIn>
        <div className={"pagecontainer"} >
            <br />
            <br />
            <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false} startIndex={galleryindex} />
        </div>
        </FadeIn>
    )
}
